<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="684"
    height="687"
    viewBox="0 0 684 687"
  >
    <g id="Logo" transform="translate(-108 -60)">
      <circle
        id="circle-1-1"
        cx="14.5"
        cy="14.5"
        r="14.5"
        transform="translate(108 61)"
        fill="#3aad5a"
      />
      <g id="Group_2" data-name="Group 2">
        <circle
          id="circle-2-1"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(183 61)"
          fill="#3aad5a"
        />
        <circle
          id="circle-2-2"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(108 136)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_3" data-name="Group 3">
        <circle
          id="circle-3-1"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(258 61)"
          fill="#3aad5a"
        />
        <circle
          id="circle-3-2"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(183 136)"
          fill="#3aad5a"
        />
        <circle
          id="circle-3-3"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(108 210)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_4" data-name="Group 4">
        <circle
          id="circle-4-1"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(344 61)"
          fill="#3aad5a"
        />
        <circle
          id="circle-4-2"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(258 136)"
          fill="#3aad5a"
        />
        <circle
          id="circle-4-3"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(183 210)"
          fill="#3aad5a"
        />
        <circle
          id="circle-4-4"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(108 330) rotate(-90)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_5" data-name="Group 5">
        <circle
          id="circle-5-1"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(432 60)"
          fill="#3aad5a"
        />
        <circle
          id="cirlce-5-2"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(339 124)"
          fill="#3aad5a"
        />
        <circle
          id="circle-5-3"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(258 211)"
          fill="#3aad5a"
        />
        <circle
          id="circle-5-4"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(172 335) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-5-5"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(108 420) rotate(-90)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_6" data-name="Group 6">
        <circle
          id="circle-6-1"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(522 60)"
          fill="#3aad5a"
        />
        <circle
          id="circle-6-2"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(427 124)"
          fill="#3aad5a"
        />
        <circle
          id="circle-6-3"
          cx="27"
          cy="27"
          r="27"
          transform="translate(335 199)"
          fill="#3aad5a"
        />
        <circle
          id="circle-6-4"
          cx="27"
          cy="27"
          r="27"
          transform="translate(247 340) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-6-5"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(172 425) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-6-6"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(109 508) rotate(-90)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_7" data-name="Group 7">
        <circle
          id="circle-7-1"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(611 61)"
          fill="#3aad5a"
        />
        <circle
          id="circle-7-2"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(517 124)"
          fill="#3aad5a"
        />
        <circle
          id="circle-7-3"
          cx="27"
          cy="27"
          r="27"
          transform="translate(423 199)"
          fill="#3aad5a"
        />
        <circle
          id="circle-7-4"
          cx="27"
          cy="27"
          r="27"
          transform="translate(333 340) rotate(-90)"
          fill="#ef2131"
        />
        <circle
          id="circle-7-5"
          cx="27"
          cy="27"
          r="27"
          transform="translate(247 429) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-7-6"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(172 513) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-7-7"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(108 569)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_8" data-name="Group 8">
        <circle
          id="circle-8-1"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(686 61)"
          fill="#3aad5a"
        />
        <circle
          id="circle-8-2"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(611 136)"
          fill="#3aad5a"
        />
        <circle
          id="circle-8-3"
          cx="27"
          cy="27"
          r="27"
          transform="translate(512 199)"
          fill="#3aad5a"
        />
        <circle
          id="circle-8-4"
          cx="27"
          cy="27"
          r="27"
          transform="translate(422 340) rotate(-90)"
          fill="#ef2131"
        />
        <circle
          id="circle-8-5"
          cx="27"
          cy="27"
          r="27"
          transform="translate(333 431) rotate(-90)"
          fill="#ef2131"
        />
        <circle
          id="circle-8-6"
          cx="27"
          cy="27"
          r="27"
          transform="translate(247 517) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-8-7"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(183 569)"
          fill="#3aad5a"
        />
        <circle
          id="circle-8-8"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(108 642)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_9" data-name="Group 9">
        <circle
          id="circle-9-1"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(761 61)"
          fill="#3aad5a"
        />
        <circle
          id="circle-9-2"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(686 136)"
          fill="#3aad5a"
        />
        <circle
          id="circle-9-3"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(611 210)"
          fill="#3aad5a"
        />
        <circle
          id="circle-9-4"
          cx="27"
          cy="27"
          r="27"
          transform="translate(511 340) rotate(-90)"
          fill="#ef2131"
        />
        <circle
          id="circle-9-5"
          cx="27"
          cy="27"
          r="27"
          transform="translate(422 431) rotate(-90)"
          fill="#ef2131"
        />
        <circle
          id="circle-9-6"
          cx="27"
          cy="27"
          r="27"
          transform="translate(333 517) rotate(-90)"
          fill="#ef2131"
        />
        <circle
          id="circle-9-7"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(258 568)"
          fill="#3aad5a"
        />
        <circle
          id="circle-9-8"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(183 642)"
          fill="#3aad5a"
        />
        <circle
          id="circle-9-9"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(108 717)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_10" data-name="Group 10">
        <circle
          id="circle-10-1"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(761 136)"
          fill="#3aad5a"
        />
        <circle
          id="circle-10-2"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(686 210)"
          fill="#3aad5a"
        />
        <circle
          id="circle-10-3"
          cx="27"
          cy="27"
          r="27"
          transform="translate(597 340) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-10-4"
          cx="27"
          cy="27"
          r="27"
          transform="translate(511 431) rotate(-90)"
          fill="#ef2131"
        />
        <circle
          id="circle-10-5"
          cx="27"
          cy="27"
          r="27"
          transform="translate(422 517) rotate(-90)"
          fill="#ef2131"
        />
        <circle
          id="circle-10-6"
          cx="27"
          cy="27"
          r="27"
          transform="translate(335 555)"
          fill="#3aad5a"
        />
        <circle
          id="circle-10-7"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(258 642)"
          fill="#3aad5a"
        />
        <circle
          id="circle-10-8"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(183 717)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_11" data-name="Group 11">
        <circle
          id="circle-11-1"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(761 211)"
          fill="#3aad5a"
        />
        <circle
          id="circle-11-2"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(681 335) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-11-3"
          cx="27"
          cy="27"
          r="27"
          transform="translate(597 429) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-11-5"
          cx="27"
          cy="27"
          r="27"
          transform="translate(423 555)"
          fill="#3aad5a"
        />
        <circle
          id="circle-11-4"
          cx="27"
          cy="27"
          r="27"
          transform="translate(511 517) rotate(-90)"
          fill="#ef2131"
        />
        <circle
          id="circle-11-6"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(339 638)"
          fill="#3aad5a"
        />
        <circle
          id="circle-11-7"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(258 717)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_12" data-name="Group 12">
        <circle
          id="circle-12-1"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(755 330) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-12-2"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(681 425) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-12-3"
          cx="27"
          cy="27"
          r="27"
          transform="translate(597 517) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-12-4"
          cx="27"
          cy="27"
          r="27"
          transform="translate(512 555)"
          fill="#3aad5a"
        />
        <circle
          id="circle-12-5"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(427 638)"
          fill="#3aad5a"
        />
        <circle
          id="circle-12-6"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(344 711)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_13" data-name="Group 13">
        <circle
          id="circle-13-1"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(755 420) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-13-2"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(681 513) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-13-3"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(611 569)"
          fill="#3aad5a"
        />
        <circle
          id="circle-13-4"
          cx="22.5"
          cy="22.5"
          r="22.5"
          transform="translate(517 638)"
          fill="#3aad5a"
        />
        <circle
          id="circle-13-5"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(432 712)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_14" data-name="Group 14">
        <circle
          id="circle-14-1"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(754 508) rotate(-90)"
          fill="#3aad5a"
        />
        <circle
          id="circle-14-2"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(686 569)"
          fill="#3aad5a"
        />
        <circle
          id="circle-14-3"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(611 642)"
          fill="#3aad5a"
        />
        <circle
          id="circle-14-4"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(522 712)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_15" data-name="Group 15">
        <circle
          id="circle-15-1"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(761 568)"
          fill="#3aad5a"
        />
        <circle
          id="circle-15-2"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(686 642)"
          fill="#3aad5a"
        />
        <circle
          id="circle-15-3"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(611 717)"
          fill="#3aad5a"
        />
      </g>
      <g id="Group_16" data-name="Group 16">
        <circle
          id="circle-16-1"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(761 642)"
          fill="#3aad5a"
        />
        <circle
          id="circle-16-2"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(686 717)"
          fill="#3aad5a"
        />
      </g>
      <circle
        id="Group_17"
        data-name="Group 17"
        cx="14.5"
        cy="14.5"
        r="14.5"
        transform="translate(763 717)"
        fill="#3aad5a"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
